var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"light","size":"sm","title":_vm.GetTitle()},on:{"click":function($event){return _vm.CopyToClipboard()}}},[(!_vm.isCopying)?_c('b-icon-clipboard'):_vm._e(),(_vm.isCopying)?_c('b-icon-check'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }